<template>
  <div id="Unconfirmed">
    <ApopBar/>
    <b-container>
      <h2>Thanks for signing up!</h2>
      <p>While you're waiting for full access here are some of our offerings.</p>

      <h4>Mumble</h4>
      <p>Apoplectic uses <a href="https://www.mumble.info/" target="_blank">Mumble</a> and <a
        href="https://discordapp.com/" target="_blank">Discord</a> for voice communication.

        Once full site access is granted you will have access to start up mumble.apoplectic.net, our on-demand mumble
        server. A Mumble ID key will be provided to you along with instructions to import the key and connect to
        mumble.apoplectic.net.
      </p>

      <h4>Steam</h4>
      <p>
        Apoplectic has, over the years, had a running thread consisting of people offering up their extra keys for the
        community to claim at no charge. This tradition continues! The updated key store is backed by a dynamoDB table
        and all members can claim and add keys.
      </p>

      <h4>Event notification and Google calendar integration</h4>
      <p>Apoplectic will now automatically send email notifications and SMS messages notifying you when events are
        scheduled including calendar invites.
      </p>

      <h4>Full Recording archive</h4>
      <p> From the secretly taped World of Warcraft sessions through the latest board and RPG actual-plays, all edited
        audio is available for members in our high availability file bucket.
      </p>
    </b-container>
  </div>

</template>

<script>
  import ApopBar from '../components/ApopBar'

  export default {
    name: 'Unconfirmed',
    components: {
      ApopBar
    }
  }
</script>
